import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { EditableContent } from '../components/EditableContent';
import { EditableImage } from '../components/EditableImage';

const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <PageHeader 
        title={
          <EditableContent
            section="about"
            contentKey="title"
            defaultValue="À propos"
          />
        }
        subtitle={
          <EditableContent
            section="about"
            contentKey="subtitle"
            defaultValue="QUI SOMMES-NOUS ?"
          />
        }
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <EditableImage
            section="about"
            imageKey="main-image"
            defaultSrc="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
            alt="Équipe professionnelle en réunion"
            className="rounded-lg shadow-lg w-full"
          />
        </div>
        
        <div className="prose max-w-none space-y-6">
          <div className="text-lg text-gray-700">
            <EditableContent
              section="about"
              contentKey="paragraph-1"
              defaultValue="Nous sommes une équipe passionnée et engagée, composée d'experts reconnus dans le domaine de l'assurance."
              type="textarea"
            />
          </div>
          
          <div className="text-lg text-gray-700">
            <EditableContent
              section="about"
              contentKey="paragraph-2"
              defaultValue="Au sein de l'ASDA, la pénurie de personnes compétentes n'est pas un sujet d'actualité : nous rassemblons les talents pour répondre aux défis d'un secteur en pleine évolution."
              type="textarea"
            />
          </div>
          
          <div className="text-lg text-gray-700">
            <EditableContent
              section="about"
              contentKey="paragraph-3"
              defaultValue="Notre mission est de soutenir nos membres à travers des formations spécialisées, des conférences enrichissantes et un accompagnement personnalisé. Nous offrons un réseau solide et des opportunités uniques pour échanger, apprendre et évoluer ensemble."
              type="textarea"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;